import Box from '@mui/material/Box';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { PromiseContainer } from '../../../../../../../components';
import { useStore } from '../../../../../../../store';
import usePromise from '../../../../../../../store/utils/usePromise';
import S3File from '../../../store/S3File';
import Navigation from '../Navigation';
import FileList from './FileList';

export default observer(function ApiBrowser({
  setSelectedFiles,
  setUrl,
  url,
}: {
  setSelectedFiles: (files: S3File[]) => void;
  setUrl: (url: string) => void;
  url: string;
}) {
  const { productStore } = useStore();
  const [filesPromise, reloadFiles] = usePromise(() =>
    productStore.fetchFileList(url),
  );

  const files = filesPromise.value;

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => setSelectedFiles(files?.selected || []), [files?.selected]);

  function loadUrl(newUrl: string) {
    setUrl(newUrl);
    reloadFiles();
  }

  return (
    <Box minHeight={240}>
      <Navigation onNavigate={loadUrl} url={url} />
      <PromiseContainer promise={filesPromise}>
        {(list) => <FileList files={list} onNavigate={loadUrl} />}
      </PromiseContainer>
    </Box>
  );
});
